export default __webpack_public_path__ + "static/media/c7.1efc8ff2.jpg";